import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  CreateCompany,
  CreateConsultant,
  ChangeCompanyStage,
  ChangeCompanyDeadlines,
} from 'imports/ComponentsImports';

import {
  AlertDialogOneButton,
  LoadingDialog,
} from 'imports/DesignImports';

import {
  CircularProgress,
  List,
  ListItem,
} from 'material-ui';

class UtilitiesView extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      staff: {},
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      alertDialogOneButton: false,
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div>
        <h1>Herramientas de utilidad</h1>
        <List>
          <ListItem
            primaryText={<h2 style={{margin: '0'}}>Crear una nueva empresa</h2>}
            primaryTogglesNestedList={true}
            nestedItems={[
              <CreateCompany
                key={0}
                cookies={this.props.cookies}
                staff={this.state.staff}
                industries={this.state.industries}
                raiseAlertOneButton={this.raiseAlertOneButton}
                raiseLoading={() => this.setState({loadingDialog: true})}/>
            ]}
            />
          <ListItem
            primaryText={<h2 style={{margin: '0'}}>Añadir consultor</h2>}
            primaryTogglesNestedList={true}
            nestedItems={[
              <CreateConsultant
                key={1}
                cookies={this.props.cookies}
                raiseAlertOneButton={this.raiseAlertOneButton}
                raiseLoading={() => this.setState({loadingDialog: true})} />
            ]}
            />
            <ListItem
              primaryText={<h2 style={{margin: '0'}}>Cambiar etapa de alguna empresa</h2>}
              primaryTogglesNestedList={true}
              nestedItems={[
                <ChangeCompanyStage
                  key={2}
                  cookies={this.props.cookies}
                  raiseAlertOneButton={this.raiseAlertOneButton}
                  raiseLoading={() => this.setState({loadingDialog: true})}
                  companies={this.state.companies}
                  stages={this.state.stages}
                  />
              ]}
              />
            <ListItem
              primaryText={<h2 style={{margin: '0'}}>Cambiar plazos de alguna empresa</h2>}
              primaryTogglesNestedList={true}
              nestedItems={[
                <ChangeCompanyDeadlines
                  key={3}
                  cookies={this.props.cookies}
                  raiseAlertOneButton={this.raiseAlertOneButton}
                  raiseLoading={() => this.setState({loadingDialog: true})}
                  companies={this.state.companies}
                  />
              ]}
              />
        </List>
        {this.state.alertDialogOneButton &&
          <AlertDialogOneButton
            title={this.state.title}
            message={this.state.message}
            acceptLabel='Aceptar'
            confirm={() => {this.setState({alertDialogOneButton: false}); }}
            />
        }
        {this.state.loadingDialog &&
          <LoadingDialog message='Estamos enviando los datos'/>
        }
      </div>
    );
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    var staff = connection.get(routes.innspiralStaff)
    var industries = connection.get(routes.industries)
    var companies = connection.get(routes.companies)
    var stages = connection.get(routes.getStages)
    Promise.all([staff, industries, companies, stages])
    .then((responses) => {
      this.setState({
        staff: responses[0].data,
        industries: responses[1].data,
        companies: responses[2].data,
        stages: responses[3].data.stages,
        loading: false,
        error: false,
      })
    })
    .catch((err) => {
      this.setState({
        loading: false,
        error: true,
      })
      console.error(err);
    })
  }

  raiseAlertOneButton = (title, message) => {
    this.setState({
      title: title,
      message: message,
      alertDialogOneButton: true,
      loadingDialog: false,
    })
  }
}

export default withCookies(withRouter(UtilitiesView));



// WEBPACK FOOTER //
// ./src/views/administration/UtilitiesView.js